import { Injectable } from '@angular/core';
import { DialogService } from './dialog.service';

@Injectable({
  providedIn: 'root',
})
export class KeyService {
  constructor(
    private dialogService: DialogService
  ) {}

  async showKeyModal() {
    await this.dialogService.keyAlert(
      'To Κλειδί έχει λήξει. Επικοινωνήστε με τον διαχειριστή.'
    );
  }
}
